import Form from "react-bootstrap/Form";
import "../../../src/main.css";
import React, { useState } from "react";
import { OverlayTrigger } from "react-bootstrap";
import { Tooltip } from "react-bootstrap";
import { Link } from "react-router-dom";

import Offcanvas from "react-bootstrap/Offcanvas";
import NewWindowLogo from "assets/img/illustrations/NewWindowLogo";
import CardDiv from "modules/common/card-div/CardDiv";

function OffCanvas({ name, ...props }) {
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  return (
    <>
      <div variant="primary" className="me-2">
        <div className="d-flex ">
          <OverlayTrigger
            overlay={
              <Tooltip
                style={{ position: "fixed" }}
                id="overlay-trigger-example"
              >
                <div className="fw-bold"> Customer Feedback</div>
              </Tooltip>
            }
          >
            <div className="pe-3" onClick={handleShow}>
              {" "}
              <NewWindowLogo />
            </div>
          </OverlayTrigger>
          <Link
            to={`/lead-details/${props?.record?.user?.caseId}`}
            className="text-primary ms-1" 
          >
            <OverlayTrigger
              overlay={
                <Tooltip
                  style={{ position: "fixed" }}
                  id="overlay-trigger-example"
                >
                  <div className="fw-bold">Lead Details</div>
                </Tooltip>
              }
            >
              <span className="ms-2">{props.userName}</span>
            </OverlayTrigger>
          </Link>
        </div>
      </div>
      <Offcanvas
        show={show}
        onHide={handleClose}
        {...props}
        style={{ width: "45%" }}
      >
        <Offcanvas.Header closeButton>
          <Offcanvas.Title>
            <h5 className="text-break">{props.userName}</h5>
          </Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
          {
            <div className="d-flex flex-column gap-3">
              <div className="flex-1">
                <CardDiv
                  title={"Did your hair coach resolve your doubts?"}
                  component={
                    <div>{props.record?.doubt_resolved ? "Yes" : "No"}</div>
                  }
                />
              </div>

              <div className="flex-1">
                <CardDiv
                  title={"Rate your traya coach?"}
                  component={<div>{props.record?.rate_your_coach}</div>}
                />
              </div>
              <div className="flex-1">
                <CardDiv
                  title={
                    "Choose your Preferred language, We will let your coach know about your choice."
                  }
                  component={<div>{props.record?.preffered_language}</div>}
                />
              </div>
              <div className="flex-1">
                <CardDiv
                  title={"Are you happy with traya?"}
                  component={<div>{props.record?.happy_with_traya}</div>}
                />
              </div>

              <div className="flex-1">
                <CardDiv
                  title={"Do you want to change your coach?"}
                  component={
                    <div>{props.record?.change_coach ? "Yes" : "No"}</div>
                  }
                />
              </div>

              <div className="flex-1">
                <CardDiv
                  title={"Tell us more. How can we serve better?"}
                  component={
                    <div className="text-black">
                      {props.record?.tell_us_more}
                    </div>
                  }
                />
              </div>
            </div>
          }
        </Offcanvas.Body>
      </Offcanvas>
    </>
  );
}

// change_coach: 0;
// createdAt: "2023-06-28T11:59:59.396Z";
// doubt_resolved: 0;
// engagement: "649c207bda596bd0549b5698";
// happy_with_traya: 2;
// preffered_language: "english";
// rate_your_coach: 2;
// Did your hair coach resolve your doubts? No
// Rate your traya coach? 4
// Choose your preffered language, We will let your coach know about your choice. english
// Are you happy with traya? 4
// Do you want to change your coach? No
// Tell us more. How can we serve better? testtstsyysgjjjas

function SupportModalFeedback({ userName, record }) {
  return (
    <>
      <OffCanvas
        key={6}
        userName={userName}
        record={record}
        placement={"end"}
        name={"Filter"}
      />
    </>
  );
}

export default SupportModalFeedback;
